export default __webpack_public_path__ + "static/media/homepage-image.e4b93e12.svg";